// meta descriptions for search engines, keyed by page route (router.pathname)
// and resolved per page at static export time. every indexable page needs its
// own text — duplicate descriptions across pages hurt SEO and get flagged by
// crawlers. utils/seo.test.ts fails when a page is added without one.
export const PAGE_DESCRIPTIONS: Record<string, string> = {
  '/': 'Provide liquidity on Chainflip to earn trading fees, lending yield, Boost rewards, and manage your cross-chain liquidity portfolio.',
  '/strategies':
    'Create and manage automated stablecoin yield strategies on Chainflip to optimize returns with minimal manual management.',
  '/lending':
    'Supply assets, borrow against collateral, and manage lending positions on Chainflip with transparent rates and real-time analytics.',
  '/boost':
    'Earn additional BTC yield through Chainflip Boost by supplying liquidity that accelerates cross-chain swap execution.',
  '/stake':
    'Stake FLIP with Chainflip validators to earn a share of network rewards from protocol fees, with operators handling auction bidding and validator management.',
  '/balances':
    'View and manage your Chainflip balances across supported assets, deposits, withdrawals, and available liquidity.',
};

// dynamic and not-yet-described routes fall back to the root description
export const getPageDescription = (pathname: string): string =>
  PAGE_DESCRIPTIONS[pathname] ?? PAGE_DESCRIPTIONS['/'];

// title tags, keyed like PAGE_DESCRIPTIONS. duplicate titles across pages hurt
// ranking and get flagged by crawlers, so every indexable page needs its own
export const PAGE_TITLES: Record<string, string> = {
  '/': 'Chainflip Apps | Earn, Borrow, Lend',
  '/strategies': 'Chainflip Stablecoin Strategies',
  '/lending': 'Chainflip Cross-Chain Lending',
  '/boost': 'Chainflip BTC Boost',
  '/stake': 'Chainflip FLIP Staking',
  '/balances': 'Chainflip Apps | Balances',
};

// dynamic and not-yet-titled routes fall back to the root title
export const getPageTitle = (pathname: string): string => PAGE_TITLES[pathname] ?? PAGE_TITLES['/'];
